export default "__VITE_ASSET__B8H1Ac4W__"